import { Meta, EmailTemplate } from 'utils/types';

const emailTemplate = (data: EmailTemplate) => ({
  ...data,
});

const emailTemplates = ({
  data,
  meta,
}: {
  data: EmailTemplate[];
  meta: Meta;
}) => ({
  nextPage: +meta.totalPages + 1 > +meta.page && +meta.page + 1,
  previousPage: +meta.page > 1 && +meta.page - 1,
  meta: { ...meta, page: +meta.page, totalPages: meta.totalPages + 1 },
  data: data.map((s) => emailTemplate(s)),
});

export default { emailTemplate, emailTemplates };
